// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IChannelDto } from './IChannelDto';
import {
    IChannelDtoFromJSON,
    IChannelDtoFromJSONTyped,
    IChannelDtoToJSON,
    IChannelDtoToJSONTyped,
} from './IChannelDto';

/**
 * 
 * @export
 * @interface IChannelRequestDto
 */
export interface IChannelRequestDto {
    /**
     * 
     * @type {IChannelDto}
     * @memberof IChannelRequestDto
     */
    channel?: IChannelDto;
    /**
     * 
     * @type {string}
     * @memberof IChannelRequestDto
     */
    session?: string;
}

/**
 * Check if a given object implements the IChannelRequestDto interface.
 */
export function instanceOfIChannelRequestDto(value: object): value is IChannelRequestDto {
    return true;
}

export function IChannelRequestDtoFromJSON(json: any): IChannelRequestDto {
    return IChannelRequestDtoFromJSONTyped(json, false);
}

export function IChannelRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChannelRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': json['channel'] == null ? undefined : IChannelDtoFromJSON(json['channel']),
        'session': json['session'] == null ? undefined : json['session'],
    };
}

export function IChannelRequestDtoToJSON(json: any): IChannelRequestDto {
    return IChannelRequestDtoToJSONTyped(json, false);
}

export function IChannelRequestDtoToJSONTyped(value?: IChannelRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channel': IChannelDtoToJSON(value['channel']),
        'session': value['session'],
    };
}

